/**
 * Types of toast messages.
 */
 export enum ToastType {
	Error = "Error",
	Info = "Info"
}